import { useEffect, useState } from "react";

export default function RowSwitch({ value, userId, onChange }) {
  // checked = ativo/inativo, então invertido: deleted = true -> switch off
  const [checked, setChecked] = useState(!value);

  useEffect(() => {
    setChecked(!value); // sincroniza caso value mude de fora
  }, [value]);

  const handleChange = (e) => {
    const newChecked = e.target.checked;
    setChecked(newChecked);

    // envia o valor invertido para refletir 'deleted'
    onChange(userId, !newChecked); // !newChecked = novo deleted
  };

  return (
    <label
      style={{
        display: "inline-block",
        width: "40px",
        height: "20px",
        position: "relative",
      }}
      onClick={(e) => e.stopPropagation()} // evita propagação para a tr
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        style={{
          opacity: 0,
          width: 0,
          height: 0,
        }}
      />
      <span
        style={{
          position: "absolute",
          cursor: "pointer",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: checked ? "#4ade80" : "#ccc",
          borderRadius: "20px",
          transition: ".2s",
        }}
      >
        <span
          style={{
            position: "absolute",
            height: "16px",
            width: "16px",
            left: checked ? "20px" : "2px",
            bottom: "2px",
            backgroundColor: "white",
            borderRadius: "50%",
            transition: ".2s",
          }}
        />
      </span>
    </label>
  );
}
